// src/pages/vendor/VendorPayPack.jsx

import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions, db } from "../../firebase";
import {
  collection,
  addDoc,
  serverTimestamp
} from "firebase/firestore";

function formatMoney(v) {
  return Number(v || 0).toLocaleString("fr-FR") + " FCFA";
}

export default function VendorPayPack() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [paying, setPaying] = useState(false);
  const [error, setError] = useState(null);
  const [phone, setPhone] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);

        const fn = httpsCallable(functions, "getVendorOnboardingInfo");

        const res = await fn({ token });

        setData(res.data);
      } catch (err) {
        console.error(err);
        setError("Impossible de charger les informations.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [token]);

  const handlePayment = async () => {
    if (!phone) {
      alert("Veuillez saisir votre numéro Mobile Money.");
      return;
    }

    try {
      setPaying(true);

      const paymentRef = await addDoc(
        collection(db, "subscriptionPayments"),
        {
          requestId: data.requestId,
          vendorUid: data.vendorUid || null,
          onboardingId: data.requestId,
          amount: data.totalFee,
          currency: "XOF",
          status: "pending",
          phone,
          paymentMethod: "mobile_money",
          createdAt: serverTimestamp()
        }
      );

      alert(
        "Votre demande de paiement a été envoyée. Vous allez recevoir une notification Mobile Money."
      );

      // ici tu peux rediriger vers une page attente
      navigate(`/vendor/onboarding?token=${token}`);

    } catch (err) {
      console.error(err);
      alert("Erreur lors du paiement.");
    } finally {
      setPaying(false);
    }
  };

  if (loading) {
    return (
      <div className="pay-page">
        <div className="pay-card">
          Chargement du pack…
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="pay-page">
        <div className="pay-card">
          <h2>Lien invalide</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pay-page">
      <div className="pay-card">

        <h1 className="pay-title">
          Paiement du pack vendeur
        </h1>

        <p className="pay-desc">
          Finalisez votre inscription en payant votre abonnement vendeur.
        </p>

        <div className="pay-pack">

          <div className="pay-row">
            <span>Pack</span>
            <strong>{data.packName}</strong>
          </div>

          <div className="pay-row">
            <span>Montant</span>
            <strong>{formatMoney(data.totalFee)}</strong>
          </div>

          <div className="pay-row">
            <span>Email</span>
            <strong>{data.email}</strong>
          </div>

        </div>

        <div className="pay-field">
          <label>Numéro Mobile Money</label>

          <input
            type="tel"
            placeholder="Ex: 99 12 34 56"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        <button
          className="pay-btn"
          disabled={paying}
          onClick={handlePayment}
        >
          {paying ? "Traitement..." : "Payer maintenant"}
        </button>

        <div className="pay-info">
          Paiement sécurisé via Mobile Money
        </div>

      </div>

      <style>{`

      .pay-page{
        min-height:100vh;
        display:flex;
        align-items:center;
        justify-content:center;
        padding:24px;
        background:linear-gradient(180deg,#eef2ff,#f8fafc);
      }

      .pay-card{
        width:100%;
        max-width:420px;
        background:white;
        border-radius:22px;
        padding:26px;
        border:1px solid #e5e7eb;
        box-shadow:0 30px 60px rgba(0,0,0,.08);
      }

      .pay-title{
        font-size:24px;
        font-weight:900;
        margin-bottom:6px;
        color:#0f172a;
      }

      .pay-desc{
        font-size:14px;
        color:#64748b;
        margin-bottom:20px;
      }

      .pay-pack{
        background:#f8fafc;
        border-radius:14px;
        padding:14px;
        margin-bottom:20px;
      }

      .pay-row{
        display:flex;
        justify-content:space-between;
        margin-bottom:8px;
      }

      .pay-field{
        margin-bottom:16px;
      }

      .pay-field label{
        display:block;
        font-weight:700;
        margin-bottom:6px;
        font-size:13px;
      }

      .pay-field input{
        width:100%;
        padding:12px;
        border-radius:12px;
        border:1px solid #d1d5db;
        font-size:14px;
      }

      .pay-btn{
        width:100%;
        padding:14px;
        border:none;
        border-radius:999px;
        background:#16a34a;
        color:white;
        font-weight:900;
        cursor:pointer;
        font-size:15px;
      }

      .pay-btn:hover{
        background:#15803d;
      }

      .pay-info{
        margin-top:14px;
        font-size:12px;
        text-align:center;
        color:#6b7280;
      }

      `}</style>
    </div>
  );
}